<div class="_beego-desktop-page">

   <ng-container *ngIf="tenantHasActiveBeegoLink === false">
      <div class="_warning-container">
         <img src="./assets/BEEGO_logo.png" width="116px" height="78px" />
         <p [innerHTML]="'API_ERRORS.BEEGO_APPOINTMENTS.NO_PARTNER_LINK' | translate"></p>
      </div>
   </ng-container>

   <ng-container *ngIf="tenantHasActiveBeegoLink">
      <segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment"
		(selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

      <ng-container [ngSwitch]="selectedSegment">

         <!-- PLANNED -->
         <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])"> 

            <table-desktop-component 
            [headers]="tableHeaders[0]"
            [filters]="tableFilters[0]"
            [dataRequest]="dataRequestPlanned" 
            (dataChanged)="dataChanged($any($event))"  
            stateKey="beego-items"
            class="_compact"
            >
               <ion-row data class="_row _data ion-align-items-center"  *ngFor="let appointment of appointments">
               
                  <!-- TOTAL SIZE = 15 -->

                  <!-- ID -->
                  <table-col [size]="1">
                     BW{{appointment.WorkOrder?._id}}
                  </table-col>

                  <!-- TYPE -->
                  <table-col [size]="1">
                     <ion-icon *ngIf="appointment.WorkOrder.Appointment" src="./assets/icons/student-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.APPOINTMENT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                     <ion-icon *ngIf="appointment.WorkOrder.Digipoint" src="./assets/icons/digipoint-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                  </table-col>

                  <!-- DATE -->
                  <table-col [size]="3">
                     <ng-container *ngIf="appointment.WorkOrder.Appointment">
                        {{appointment.WorkOrder?.Appointment.appointmentDate | date:"EEEE d/MM/yy" }}<br>
                        {{appointment.WorkOrder?.Appointment.appointmentTime | time:true }}
                     </ng-container>
                     <ng-container *ngIf="appointment.WorkOrder.Digipoint">
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"EEEE d/MM/yy"}}<br>
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"HH:mm" | time }} - {{appointment.WorkOrder?.CalendarEvent?.endsAt | date:"HH:mm" | time }}
                     </ng-container>                  
                  </table-col>
                  
                  <!-- CLIENT -->
                  <table-col [size]="4">  
                     <ng-container  *ngIf="appointment.WorkOrder?.Digipoint">
                        {{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}: {{appointment.WorkOrder?.Digipoint?.name}}<br>
                        <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder?.Digipoint?.DigipointAddress]">{{appointment.WorkOrder?.Digipoint?.DigipointAddress | address}}</span>
                     </ng-container>
   
                     <ng-container  *ngIf="appointment.WorkOrder?.Appointment">
                        <ng-container *ngIf="appointment.Client">
                           <span class="_link" (click)="openClient(appointment.Client.id)">
                              {{appointment.Client.firstname}} {{appointment.Client.lastname}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.Client.Address]">{{appointment.Client.Address | address}}</span>
                        </ng-container>
                        <ng-container *ngIf="!appointment.Client">
                           <span>
                              {{appointment.WorkOrder?.Appointment?.Client?.firstname}} {{appointment.WorkOrder?.Appointment?.Client?.name}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder.Appointment.Client.ClientAddress]">
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.street}} 
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.housenumber}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.floor}},
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.zipcode}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.city}}
                           </span>
                        </ng-container>
                     </ng-container>
                  </table-col>

                  <!-- EMPLOYEE -->
                  <table-col [size]="3">
                     {{appointment.WorkOrder?.Employee?.firstname}}
                     {{appointment.WorkOrder?.Employee?.name}}
                  </table-col>

                  <!-- QUESTION -->
                  <table-col class="_col _appointment-problem" [size]="2">
                     <ion-icon *ngIf="appointment.WorkOrder?.Appointment?.problem" src="./assets/icons/chat-outline.svg" tooltip="{{appointment.WorkOrder?.Appointment?.problem}}" [hideDelay]="0" theme="light"></ion-icon>
                  </table-col>  
                  
                  <!-- MORE -->
                  <table-col [size]="1">
                     <button type="button" class="_button _info-button" title="{{ 'DEVICE.EDIT' | translate}}" (click)="openAppointment(appointment?.AppointmentId ? appointment?.AppointmentId : appointment.WorkOrder.id  )">
                           <ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
                     </button>
                  </table-col>
               </ion-row>
            </table-desktop-component>   
         </div> 

         <!-- FINISHED -->
         <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">
            <table-desktop-component 
            [headers]="tableHeaders[1]"
            [filters]="tableFilters[1]"
            [dataRequest]="dataRequestFinished" 
            (dataChanged)="dataChanged($any($event))"  
            stateKey="beego-items"
            >
               <ion-row data class="_row _data ion-align-items-center"  *ngFor="let appointment of appointments">
               
                  <!-- TOTAL SIZE = 15 -->

                  <!-- ID -->
                  <table-col [size]="1">
                     BW{{appointment.WorkOrder?._id}}
                  </table-col>

                  <!-- TYPE -->
                  <table-col [size]="1">
                     <ion-icon *ngIf="appointment.WorkOrder.Appointment" src="./assets/icons/student-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.APPOINTMENT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                     <ion-icon *ngIf="appointment.WorkOrder.Digipoint" src="./assets/icons/digipoint-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                  </table-col>                

                  <!-- DATE -->
                  <table-col [size]="3">
                     <ng-container *ngIf="appointment.WorkOrder.Appointment">
                        {{appointment.WorkOrder?.Appointment.appointmentDate | date:"EEEE d/MM/yy" }}<br>
                        {{appointment.WorkOrder?.Appointment.appointmentTime | time:true }}
                     </ng-container>
                     <ng-container *ngIf="appointment.WorkOrder.Digipoint">
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"EEEE d/MM/yy"}}<br>
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"HH:mm" | time }} - {{appointment.WorkOrder?.CalendarEvent?.endsAt | date:"HH:mm" | time }}
                     </ng-container>                  
                  </table-col>

                  <!-- CLIENT -->
                  <table-col [size]="4">  
                     <ng-container  *ngIf="appointment.WorkOrder?.Digipoint">
                        {{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}: {{appointment.WorkOrder?.Digipoint?.name}}<br>
                        <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder?.Digipoint?.DigipointAddress]">{{appointment.WorkOrder?.Digipoint?.DigipointAddress | address}}</span>
                     </ng-container>
   
                     <ng-container  *ngIf="appointment.WorkOrder?.Appointment">
                        <ng-container *ngIf="appointment.Client">
                           <span class="_link" (click)="openClient(appointment.Client.id)">
                              {{appointment.Client.firstname}} {{appointment.Client.lastname}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.Client.Address]">{{appointment.Client.Address | address}}</span>
                        </ng-container>
                        <ng-container *ngIf="!appointment.Client">
                           <span>
                              {{appointment.WorkOrder?.Appointment?.Client?.firstname}} {{appointment.WorkOrder?.Appointment?.Client?.name}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder.Appointment.Client.ClientAddress]">
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.street}} 
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.housenumber}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.floor}},
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.zipcode}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.city}}
                           </span>
                        </ng-container>
                     </ng-container>
                  </table-col>

                  <!-- EMPLOYEE -->
                  <table-col [size]="3">
                     {{appointment.WorkOrder?.Employee?.firstname}}
                     {{appointment.WorkOrder?.Employee?.name}}
                  </table-col>

                  <!-- RATING -->
                  <table-col class="_col _appointment-rating-score" [size]="2">
                     <span tooltip="{{appointment.WorkOrder?.Appointment?.Rating?.description}}" [hideDelay]="0" theme="light">
                        @if (appointment.WorkOrder?.Appointment?.Rating?.score) {
                           @for (i of [1,2,3,4,5]; track $index) {
                              @if (appointment.WorkOrder?.Appointment?.Rating?.score >= i) {
                                  <ion-icon src="./assets/icons/star.svg"></ion-icon>
                              } @else {
                                  <ion-icon style="color: lightgrey" src="./assets/icons/star-outline.svg"></ion-icon>
                              }
                              
                          }
                        }
                     </span>
                  </table-col>


                  <!-- MORE -->
                  <table-col [size]="1">
                     <button type="button" class="_button _info-button" title="{{ 'DEVICE.EDIT' | translate}}" (click)="openAppointment(appointment?.AppointmentId ? appointment?.AppointmentId : appointment?.WorkOrder?.id  )">
                           <ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
                     </button>
                  </table-col>                    
               </ion-row>
            </table-desktop-component>
         </div> 


         <!-- CANCELED -->
         <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[2])">
            <table-desktop-component 
            [headers]="tableHeaders[2]"
            [filters]="tableFilters[2]"
            [dataRequest]="dataRequestCanceled" 
            (dataChanged)="dataChanged($any($event))"  
            stateKey="beego-items"
            >
               <ion-row data class="_row _data ion-align-items-center"  *ngFor="let appointment of appointments">
               
                  <!-- TOTAL SIZE = 15 -->

                  <!-- ID -->
                  <table-col [size]="1">
                     BW{{appointment.WorkOrder?._id}}
                  </table-col>


                  <!-- TYPE -->
                  <table-col [size]="1">
                     <ion-icon *ngIf="appointment.WorkOrder.Appointment" src="./assets/icons/student-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.APPOINTMENT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                     <ion-icon *ngIf="appointment.WorkOrder.Digipoint" src="./assets/icons/digipoint-outline.svg" tooltip="{{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}" [hideDelay]="0" theme="light"></ion-icon>
                  </table-col>                


                  <!-- DATE -->
                  <table-col [size]="3">
                     <ng-container *ngIf="appointment.WorkOrder.Appointment">
                        {{appointment.WorkOrder?.Appointment.appointmentDate | date:"EEEE d/MM/yy" }}<br>
                        {{appointment.WorkOrder?.Appointment.appointmentTime | time:true }}
                     </ng-container>
                     <ng-container *ngIf="appointment.WorkOrder.Digipoint">
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"EEEE d/MM/yy"}}<br>
                        {{appointment.WorkOrder?.CalendarEvent?.startsAt | date:"HH:mm" | time }} - {{appointment.WorkOrder?.CalendarEvent?.endsAt | date:"HH:mm" | time }}
                     </ng-container>                  
                  </table-col>
                  

                  <!-- CLIENT -->
                  <table-col [size]="4">  
                     <ng-container  *ngIf="appointment.WorkOrder?.Digipoint">
                        {{'BEEGO_APPOINTMENT.TYPE.DIGIPOINT' | translate}}: {{appointment.WorkOrder?.Digipoint?.name}}<br>
                        <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder?.Digipoint?.DigipointAddress]">{{appointment.WorkOrder?.Digipoint?.DigipointAddress | address}}</span>
                     </ng-container>
   
                     <ng-container *ngIf="appointment.WorkOrder?.Appointment">
                        <ng-container *ngIf="appointment.Client">
                           <span class="_link" (click)="openClient(appointment.Client.id)">
                              {{appointment.Client.firstname}} {{appointment.Client.lastname}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.Client.Address]">{{appointment.Client.Address | address}}</span>
                        </ng-container>
                        <ng-container *ngIf="!appointment.Client">
                           <span>
                              {{appointment.WorkOrder?.Appointment?.Client?.firstname}} {{appointment.WorkOrder?.Appointment?.Client?.name}}
                           </span>
                           <br>
                           <span [navigate]="[InternalNavigationType.address, appointment.WorkOrder.Appointment.Client.ClientAddress]">
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.street}} 
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.housenumber}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.floor}},
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.zipcode}}
                              {{appointment.WorkOrder.Appointment.Client.ClientAddress.city}}
                           </span>
                        </ng-container>
                     </ng-container>
                  </table-col>


                  <!-- EMPLOYEE -->
                  <table-col [size]="2">
                     {{appointment.WorkOrder?.Employee?.firstname}}
                     {{appointment.WorkOrder?.Employee?.name}}
                  </table-col>

                  <!-- REASON -->
                  <table-col [size]="3">             
                     <span *ngIf="appointment.WorkOrder?.WorkOrderCancellation?.atFault">{{'BEEGO_APPOINTMENT.AT_FAULT.TITLE' | translate }}

                        <ng-container *ngIf="(appointment.WorkOrder?.WorkOrderCancellation?.atFault ?? []).includes('partner') && appointment.CancelledBy">
                           {{appointment.CancelledBy.Employee.firstname}} {{appointment.CancelledBy.Employee.lastname}} ({{appointment.CancelledBy.email}})
                        </ng-container>
      
                        <ng-container *ngIf="!(appointment.WorkOrder?.WorkOrderCancellation?.atFault ?? []).includes('partner')">
                           <ng-container *ngFor="let atFault of appointment.WorkOrder?.WorkOrderCancellation?.atFault">
                              {{"BEEGO_APPOINTMENT.AT_FAULT."+atFault | uppercase | translate }}
                           </ng-container>	
                        </ng-container>:</span> 
                        {{appointment.WorkOrder?.WorkOrderCancellation?.reason}}<br/>
                        <b>
                           ({{'BEEGO_APPOINTMENT.AT_FAULT.ON' | translate }}:  {{appointment.WorkOrder?.WorkOrderCancellation?.createdAt | date:"d/MM/yy"}}, {{appointment.WorkOrder?.WorkOrderCancellation?.createdAt | date:"HH:mm" | time}})
                        </b>
                  </table-col>


                  <!-- MORE -->
                  <table-col [size]="1">
                     <button type="button" class="_button _info-button" title="{{ 'DEVICE.EDIT' | translate}}" (click)="openAppointment(appointment?.AppointmentId ? appointment?.AppointmentId : appointment.WorkOrder.id  )">
                           <ion-icon src="./assets/icons/info-outline.svg"></ion-icon>
                     </button>
                  </table-col>    
               </ion-row>
            </table-desktop-component>
         </div>  
      </ng-container>
   </ng-container>

   
</div>